import { PositionID } from './Positions/Constants';

export type DataItem = {
  userId: string;
  timestamp: string;
};

export type BaseUserMessage = {
  role: 'user' | 'system' | 'assistant';
  content: string;
};

export type UserMessage = DataItem & BaseUserMessage;

export enum InterviewStatus {
  INTERVIEW_NOT_STARTED = 'INTERVIEW_NOT_STARTED',
  INTERVIEW_STARTED = 'INTERVIEW_STARTED',
  LAST_QUESTION_STARTED = 'LAST_QUESTION_STARTED',
  INTERVIEW_COMPLETED = 'INTERVIEW_COMPLETED',
  INTERVIEW_EXPIRED = 'INTERVIEW_EXPIRED',
}

export const MessageBlockingInterviewStatuses = [
  InterviewStatus.INTERVIEW_EXPIRED,
  InterviewStatus.INTERVIEW_COMPLETED,
];

export type BaseUserInfo = {
  threadId?: string;
  rating?: number;
  status?: InterviewStatus;
  /**
   * Unix timestamp in milliseconds (GMT EPOCH), when the status was last updated.
   * */
  statusTimestamp?: number;
};

export type UserInfo = DataItem & BaseUserInfo;

export enum USState {
  ALABAMA = 'Alabama',
  ALASKA = 'Alaska',
  ARIZONA = 'Arizona',
  ARKANSAS = 'Arkansas',
  CALIFORNIA = 'California',
  COLORADO = 'Colorado',
  CONNECTICUT = 'Connecticut',
  DELAWARE = 'Delaware',
  FLORIDA = 'Florida',
  GEORGIA = 'Georgia',
  HAWAII = 'Hawaii',
  IDAHO = 'Idaho',
  ILLINOIS = 'Illinois',
  INDIANA = 'Indiana',
  IOWA = 'Iowa',
  KANSAS = 'Kansas',
  KENTUCKY = 'Kentucky',
  LOUISIANA = 'Louisiana',
  MAINE = 'Maine',
  MARYLAND = 'Maryland',
  MASSACHUSETTS = 'Massachusetts',
  MICHIGAN = 'Michigan',
  MINNESOTA = 'Minnesota',
  MISSISSIPPI = 'Mississippi',
  MISSOURI = 'Missouri',
  MONTANA = 'Montana',
  NEBRASKA = 'Nebraska',
  NEVADA = 'Nevada',
  NEW_HAMPSHIRE = 'New Hampshire',
  NEW_JERSEY = 'New Jersey',
  NEW_MEXICO = 'New Mexico',
  NEW_YORK = 'New York',
  NORTH_CAROLINA = 'North Carolina',
  NORTH_DAKOTA = 'North Dakota',
  OHIO = 'Ohio',
  OKLAHOMA = 'Oklahoma',
  OREGON = 'Oregon',
  PENNSYLVANIA = 'Pennsylvania',
  RHODE_ISLAND = 'Rhode Island',
  SOUTH_CAROLINA = 'South Carolina',
  SOUTH_DAKOTA = 'South Dakota',
  TENNESSEE = 'Tennessee',
  TEXAS = 'Texas',
  UTAH = 'Utah',
  VERMONT = 'Vermont',
  VIRGINIA = 'Virginia',
  WASHINGTON = 'Washington',
  WEST_VIRGINIA = 'West Virginia',
  WISCONSIN = 'Wisconsin',
  WYOMING = 'Wyoming',
}

export enum CanadianProvince {
  ALBERTA = 'Alberta',
  BRITISH_COLUMBIA = 'British Columbia',
  MANITOBA = 'Manitoba',
  NEW_BRUNSWICK = 'New Brunswick',
  NEWFOUNDLAND_AND_LABRADOR = 'Newfoundland and Labrador',
  NOVA_SCOTIA = 'Nova Scotia',
  ONTARIO = 'Ontario',
  PRINCE_EDWARD_ISLAND = 'Prince Edward Island',
  QUEBEC = 'Quebec',
  SASKATCHEWAN = 'Saskatchewan',
  NORTHWEST_TERRITORIES = 'Northwest Territories',
  NUNAVUT = 'Nunavut',
  YUKON = 'Yukon',
}

export type StateOrProvince = USState | CanadianProvince | string;

export type BaseProfile = {
  complete?: boolean;
  prefaceRead?: boolean;
  linkedInUrl?: string;
  city?: string;
  state?: StateOrProvince;
  idCode?: string;
  positionID?: PositionID;
};

export type Profile = DataItem & BaseProfile;

export type ProfileForAdmin = Profile &
  UserInfo & {
    resumeDownloadUrl?: string;
    audioSampleDownloadUrl?: string;
  };

export type User = {
  date_created: number;
  preferred_username: string;
  username: string;
  given_name: string;
  family_name: string;
  email: string;
  phone_number: string;
  sub: string;
};

export type UserWithStatusInfo = User & {
  status?: InterviewStatus;
  statusTimestamp?: number;
};

export type UserListInfo = {
  cursor?: string;
  users: (User | UserWithStatusInfo)[];
};
